import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Helmet from "react-helmet";
import PageHeader from "Component/Headers/pageHeader";
import headersList from "Constants/headersList";
import { bindActionCreators } from "redux";
import { CheckActionPermission } from "Actions/commonAction";
import { instance } from "Actions/AxiosInstance";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import Button from "@material-ui/core/Button";
import emptylist from "../../../../../../Assets/Svg/illustration-no-policy.svg";
import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../../business-configration/commons";
import Create from "./Create";
import CustomLoader from "Component/CustomLoader";


const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  drawerPaper: {
    width: "30%",
  },
});

let CALLAPI = true;

class PayrollFnf extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: 1,
      permissions: { editable: true, readonly: true },
      data: true,
      createmenu: false,
      selectedRow: null,
      headers: [
        {
          key: "fnfpolicyname",
          name: "FnF policy name",
          type: TDTypeConsts.EXPENSE_POLICY_NAME,
          style: { textAlign: "left" },
        },

        {
          key: "fullname",
          name: "Created By",
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "addeddate",
          name: "Created Date",
          type: TDTypeConsts.OPTIONAL_HOLIDAY_DATE,
        },
        {
          key: "assignemployee",
          name: "Assigned employee",
          type: TDTypeConsts.ASSIGNED_USER,
        },
        {
          key: "edit",
          name: "",
          type: TDTypeConsts.EDIT_WITHOUT_HEADER,
        },
        {
          key: "delete",
          name: "",
          type: TDTypeConsts.DELETE_WITHOUT_HEADER_FOR_FBP,
        },
      ],
      plans: [],
      totalcount: 1,
      limit: 20,
      offset: 0,
      isedit: false,
    };

    this.renderList = this.renderList.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.getList = this.getList.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("fnfconfig");
    if (isTrue) {
      this.setState({ permissions }, () => {
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.EDIT_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.DELETE_WITHOUT_HEADER_FOR_FBP,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
        this.getList();
        if (
          this.props.history.location.pathname.includes("create") ||
          this.props.history.location.pathname.includes("edit")
        ) {
          this.props.history.push(`${this.props.match.path}`);
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getList(isRefresh = false) {
    const { totalcount, offset, plans, limit } = this.state;
    if (CALLAPI) {
      if (totalcount && offset < totalcount) {
        CALLAPI = false;
        this.setState({ isloading: true }, () => {


          instance
            .post(`payroll/getallfnfpolicy`, { limit, offset })
            .then((result) => {
              let ListData = [];
              CALLAPI = true;
              isRefresh
                ? (ListData = result.data.result)
                : (ListData = [...plans, ...result.data.result]);
              this.setState({
                isloading: false,
                plans: ListData,
                datareceived: true,
                offset: offset + this.state.limit,
                totalcount: ListData[0] ? ListData[0].fullcount : 1,
                postData: {
                  fnfpolicyid: null,
                  fnfpolicyname: null,
                  ispaiduptolastday: true,
                  stoppaymentday: 0,
                  processday: 0,
                  ispaidencashment: false,
                  ispaidgratuity: false,
                  gratuityyear: 4,
                  gratuitymonth: 6,
                  isincludefromresigned: false,
                  isgratuitynonctc: false,
                  isdraft: false,
                  fbpcomponent: [],
                },
              });

            })
            .catch(() => {
              this.setState({
                datareceived: true,
              });
            });
        })
      }
    }
  }

  onCreate() {
    this.setState(
      {
        postData: {
          fnfpolicyid: null,
          fnfpolicyname: null,
          ispaiduptolastday: true,
          isincludefromresigned: false,
          stoppaymentday: 0,
          processday: 0,
          ispaidencashment: false,
          ispaidgratuity: false,
          gratuityyear: 4,
          gratuitymonth: 6,
          isgratuitynonctc: false,
        },
      },
      () => {
        this.props.history.push(`${this.props.match.path}/create`);
      },
    );
  }

  onEdit(item) {
    instance
      .get(`payroll/getfnfpolicybyid/${item.fnfpolicyid}`)
      .then((result) => {
        const postData = result.data.result[0];
        this.setState(
          {
            postData,
          },
          () => {
            this.props.history.push(`${this.props.match.path}/edit`);
          },
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onDelete(item) {
    instance
      .post("payroll/deletefnfpolicy", {
        fnfpolicyid: item.fnfpolicyid,
      })
      .then(() => {
        this.props.enqueueSnackbar("Successfully deleted.", {
          variant: "success",
        });
        this.setState(
          {
            totalcount: 1,
            limit: 20,
            offset: 0,
          },
          () => {
            this.getList(true);
          },
        );
      })
      .catch((error) => {
        const msg =
          error.response &&
          error.response.data &&
          error.response.data.error.message;
        this.props.enqueueSnackbar(msg || "", {
          variant: "error",
        });
      });
  }

  onCancel() {
    this.props.history.push(`${this.props.match.path}`);
    this.setState(
      {
        postData: {
          fnfpolicyid: null,
          fnfpolicyname: null,
          ispaiduptolastday: true,
          isincludefromresigned: false,

          stoppaymentday: null,
          processday: null,
          ispaidencashment: false,
          ispaidgratuity: false,
          gratuityyear: null,
          gratuitymonth: null,
          isgratuitynonctc: false,
        },
        offset: 0,
        totalcount: 1,
      },
      () => this.getList(true),
    );
  }

  renderList() {
    return (
      <div className="content-outer-wrapper">
        <PageHeader header="FnF policy" />
        {this.state.isloading ?
          <div>...load</div>

          : <List
            onCreate={this.onCreate}
            list={this.state.plans}
            headers={this.state.headers}
            permissions={this.state.permissions}
            onEdit={this.onEdit}
            onDelete={this.onDelete}
            module="FnF Policie"
          />

        }
      </div>
    );
  }

  render() {
    return (
      <IntlProvider locale="en" messages={""}>
        <div>
          <Helmet>
            <title>{headersList.Payroll.Payroll_Fnf.header}</title>
          </Helmet>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              {this.state.isloading ? 
              <div> <CustomLoader /></div>
             : <div>
              {this.props.history.location.pathname.includes("create") ||
                this.props.history.location.pathname.includes("edit") ? (
                <Create
                  {...this.props}
                  onCreate={this.props.history.location.pathname.includes(
                    "create",
                  )}
                  {...this.state}
                  getList={this.getList}
                  updatePostData={this.updatePostData}
                  postData={this.state.postData}
                  onCancel={this.onCancel}
                  onSave={this.onSave}
                />
              ) : this.state.plans.length > 0 ? (
                <div>{this.renderList()}</div>
              ) : (
                <div className="content-outer-wrapper">
                  <CreateComp
                    text="Create your first FnF policy to get started"
                    heading="There are no FnF policies to display yet!"
                    onCreate={() =>
                      this.props.history.push(`${this.props.match.path}/create`)
                    }
                    imageSrc={emptylist}
                    permissions={this.state.permissions}
                  />
                </div>
              )}
              </div>
              
            }
            </div>
          )}
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(withSnackbar(PayrollFnf))),
);
